import http from "../utils/http-common";

class VehicleTypeDataService {
  getAll() {
    return http.get("/vehicle-type");
  }

  get(id) {
    return http.get(`/vehicle-type/${id}`);
  }

  create(data) {
    return http.post("/vehicle-type", data);
  }

  update(id, data) {
    return http.put(`/vehicle-type/${id}`, data);
  }

  delete(id) {
    return http.delete(`/vehicle-type/${id}`);
  }
}

export default new VehicleTypeDataService();
